import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import { Button, Popover } from '@wordpress/components';
import { chevronDown } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import LinkViewer from './link-viewer';
import LinkEditor from './link-editor';

function URLPopover(_ref) {
  let {
    additionalControls,
    children,
    renderSettings,
    position = 'bottom center',
    focusOnMount = 'firstElement',
    ...popoverProps
  } = _ref;
  const [isSettingsExpanded, setIsSettingsExpanded] = useState(false);
  const showSettings = !!renderSettings && isSettingsExpanded;

  const toggleSettingsVisibility = () => {
    setIsSettingsExpanded(!isSettingsExpanded);
  };

  return createElement(Popover, _extends({
    className: "block-editor-url-popover",
    focusOnMount: focusOnMount,
    position: position
  }, popoverProps), createElement("div", {
    className: "block-editor-url-popover__input-container"
  }, createElement("div", {
    className: "block-editor-url-popover__row"
  }, children, !!renderSettings && createElement(Button, {
    className: "block-editor-url-popover__settings-toggle",
    icon: chevronDown,
    label: __('Link settings'),
    onClick: toggleSettingsVisibility,
    "aria-expanded": isSettingsExpanded
  })), showSettings && createElement("div", {
    className: "block-editor-url-popover__row block-editor-url-popover__settings"
  }, renderSettings())), additionalControls && !showSettings && createElement("div", {
    className: "block-editor-url-popover__additional-controls"
  }, additionalControls));
}

URLPopover.LinkEditor = LinkEditor;
URLPopover.LinkViewer = LinkViewer;
/**
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/block-editor/src/components/url-popover/README.md
 */

export default URLPopover;
//# sourceMappingURL=index.js.map